import { useCallback, useMemo } from 'react'

export const useFundingAmountStepper = (params: {
  amount?: number
  fixedIncrementStep?: number
  fixedDecrementStep?: number
  maxValue: number
  setAmount(next: number): void
}) => {
  const amountValue = params.amount ?? 0

  const percentageStep = useMemo(() => (amountValue > 0 ? amountValue * 0.1 : 0), [amountValue])
  const incrementStep = params.fixedIncrementStep ?? percentageStep
  const decrementStep = params.fixedDecrementStep ?? percentageStep

  const canDecrease = decrementStep > 0 && amountValue - decrementStep >= 0
  const canIncrease = incrementStep > 0 && amountValue + incrementStep <= params.maxValue

  const bump = useCallback(
    (dir: 'inc' | 'dec') => {
      const stepValue = dir === 'inc' ? incrementStep : decrementStep
      if (stepValue <= 0) return
      const delta = dir === 'inc' ? stepValue : -stepValue
      const next = Math.min(Math.max(amountValue + delta, 0), params.maxValue)
      params.setAmount(Math.round(next * 100) / 100)
    },
    [amountValue, decrementStep, incrementStep, params]
  )

  return {
    amountValue,
    canDecrease,
    canIncrease,
    onDecrease: () => bump('dec'),
    onIncrease: () => bump('inc'),
  }
}
